$(document).ready(function() {
  // Detect mobile screen size (for example, less than 768px)
  function checkScreenSize() {
    return $(window).width() < 768;
  }

  // Toggle the sidebar visibility for mobile only
  $(document).on('click', '.side-categories', function() {
    if (checkScreenSize()) {
      $('.sidebar').toggleClass('active'); // Toggling 'active' class on the sidebar
    }
  });

  // Ensure the sidebar is visible in desktop mode (when the screen is resized)
  $(window).resize(function() {
    if (!checkScreenSize()) {
      $('.sidebar').removeClass('active'); // Remove 'active' class on desktop
    }
  });
});
